import React, { useEffect, useState } from "react";

const API = "https://live-evo.com/api";

const NEON_CYAN = "#00f2ff";
const NEON_RED = "#ff003c";
const NEON_PURPLE = "#bc13fe";
const NEON_GREEN = "#39ff14";

function AdminStatsWebPage() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadStats = async () => {
    try {
      setLoading(true);

      const res = await fetch(`${API}/coins/admin/stats`);
      const data = await res.json();

      setStats(data);
    } catch (err) {
      console.error("Erreur stats admin:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadStats();
  }, []);

  const growthStats = [
    {
      label: "Inscrits",
      value: stats?.totalUsers ?? 0,
      sub: "Total utilisateurs",
      icon: "👥",
      color: NEON_CYAN
    },
    {
      label: "Vidéos",
      value: stats?.totalVideos ?? 0,
      sub: "Total publiées",
      icon: "🎥",
      color: NEON_GREEN
    },
    {
      label: "Messages",
      value: stats?.totalMessages ?? 0,
      sub: "Messages privés",
      icon: "💬",
      color: "#ffaa00"
    },
    {
      label: "Cadeaux",
      value: stats?.totalGifts ?? 0,
      sub: "Cadeaux envoyés",
      icon: "🎁",
      color: NEON_PURPLE
    }
  ];

  const securityStats = [
    {
      label: "Signalements",
      value: stats?.totalReports ?? 0,
      sub: "À modérer",
      icon: "🚩",
      color: "#ffff00"
    },
    {
      label: "Bannis",
      value: stats?.totalBanned ?? 0,
      sub: "Comptes bloqués",
      icon: "🚫",
      color: NEON_RED
    },
    {
      label: "Staff actifs",
      value: stats?.totalStaff ?? 0,
      sub: "Modération",
      icon: "🛡️",
      color: NEON_CYAN
    },
    {
      label: "Santé API",
      value: "OK",
      sub: "Backend actif",
      icon: "🟢",
      color: NEON_GREEN
    }
  ];

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#000",
        color: "#fff"
      }}
    >
      <div
        style={{
          padding: "30px 20px",
          background: "#050505",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #1a1a1a"
        }}
      >
        <button
          onClick={() => {
            window.location.href = "/admin";
          }}
          style={{
            background: "transparent",
            border: "none",
            color: NEON_CYAN,
            fontSize: 11,
            fontWeight: "bold",
            cursor: "pointer"
          }}
        >
          ← DASHBOARD
        </button>

        <div
          style={{
            color: "#fff",
            fontWeight: "bold",
            fontSize: 12,
            letterSpacing: 1
          }}
        >
          📊 MONITORING GLOBAL
        </div>

        <div
          style={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            background: NEON_GREEN
          }}
        />
      </div>

      {loading ? (
        <div
          style={{
            minHeight: "70vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <div
            style={{
              color: NEON_CYAN,
              fontSize: 18,
              marginBottom: 10
            }}
          >
            ⏳
          </div>

          <div style={{ color: "#8fa6ad" }}>
            Chargement des stats...
          </div>
        </div>
      ) : (
        <div
          style={{
            padding: 15,
            paddingBottom: 80,
            maxWidth: 1400,
            margin: "0 auto"
          }}
        >
          <div
            style={{
              fontSize: 11,
              fontWeight: "bold",
              color: NEON_CYAN,
              marginTop: 15,
              marginBottom: 15,
              textTransform: "uppercase",
              letterSpacing: 1
            }}
          >
            📈 Croissance & Flux
          </div>

          <div style={gridStyle}>
            {growthStats.map((stat, i) => (
              <div
                key={i}
                style={{
                  ...cardStyle,
                  border: `1px solid ${stat.color}`
                }}
              >
                <div style={{ fontSize: 20, marginBottom: 8 }}>
                  {stat.icon}
                </div>

                <div
                  style={{
                    fontSize: 24,
                    fontWeight: "bold",
                    color: stat.color
                  }}
                >
                  {stat.value}
                </div>

                <div
                  style={{
                    color: "#fff",
                    fontSize: 11,
                    fontWeight: "bold",
                    marginTop: 4
                  }}
                >
                  {stat.label}
                </div>

                <div
                  style={{
                    color: "#555",
                    fontSize: 9,
                    marginTop: 4
                  }}
                >
                  {stat.sub}
                </div>
              </div>
            ))}
          </div>

          <div
            style={{
              fontSize: 11,
              fontWeight: "bold",
              color: NEON_RED,
              marginTop: 25,
              marginBottom: 15,
              textTransform: "uppercase",
              letterSpacing: 1
            }}
          >
            🛡️ Sécurité & Modération
          </div>

          <div style={gridStyle}>
            {securityStats.map((stat, i) => (
              <div
                key={i}
                style={{
                  ...cardStyle,
                  background: "#120202",
                  border: `1px solid ${stat.color}`
                }}
              >
                <div style={{ fontSize: 20, marginBottom: 8 }}>
                  {stat.icon}
                </div>

                <div
                  style={{
                    fontSize: 24,
                    fontWeight: "bold",
                    color: stat.color
                  }}
                >
                  {stat.value}
                </div>

                <div
                  style={{
                    color: "#fff",
                    fontSize: 11,
                    fontWeight: "bold",
                    marginTop: 4
                  }}
                >
                  {stat.label}
                </div>

                <div
                  style={{
                    color: "#555",
                    fontSize: 9,
                    marginTop: 4
                  }}
                >
                  {stat.sub}
                </div>
              </div>
            ))}
          </div>

          <button
            onClick={loadStats}
            style={{
              marginTop: 25,
              background: "#00f2ff10",
              padding: 15,
              borderRadius: 10,
              border: `1px solid ${NEON_CYAN}`,
              color: NEON_CYAN,
              fontWeight: "bold",
              width: "100%",
              cursor: "pointer"
            }}
          >
            🔄 RAFRAÎCHIR LES STATS
          </button>
        </div>
      )}
    </div>
  );
}

const gridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit,minmax(240px,1fr))",
  gap: 15
};

const cardStyle = {
  background: "#0a0a0a",
  padding: 15,
  borderRadius: 12
};

export default AdminStatsWebPage;
